import { getAppGlobals } from '~/components/AppGlobals/utils';

const multipleChoiceSeparator = getAppGlobals().VITE_ORCHID_V2_MULTIPLE_CHOICE_SEPARATOR || '||';

/**
 * Parses the multiple choice value
 * @param value - The value to parse
 * @returns The parsed value
 */
export const parseMultipleChoiceValue = (value: string | string[] | null): string[] | null => {
  if (!value) return null;

  if (typeof value === 'string') {
    return value
      .split(multipleChoiceSeparator)
      .map((v) => v.trim())
      .filter((v) => v.length > 0);
  }

  if (Array.isArray(value)) {
    return value;
  }

  return null;
};
